export function replaceSpacesWithUnderscore(text: string): string {
  return text
    .replace(/\//g, '')
    .replace(/ /g, '_');
}

